import { createFileRoute } from '@tanstack/react-router';
import { OrderDetails } from '@/features/orders/OrderDetails';

export const Route = createFileRoute('/a/orders/$orderUuid')({
  staticData: {
    breadcrumbs: [{ label: 'Orders', url: '/a/orders' }, { label: 'Order Details' }],
  },
  component: AdminOrderDetailsPage,
});

function AdminOrderDetailsPage() {
  const { orderUuid } = Route.useParams();
  return <OrderDetails orderUuid={orderUuid} />;
}
